import {
  Dashboard,
  Notification,
  Profile,
  Setting,
  Support,
  Transaction,
  Wallet,
  ForgetPassword,
  ResetPassword,
} from "../pages";
import {
  WalletListing,
  TransactionsListing,
  UsersListing,
  PaymentGatewaysListing,
  ServiceProviderListing,
} from "../pages";

import { MainRoutes, NAV_ROUTES, ADMIN_ROUTES } from "../Services/Routes/App";

export const mainroutes = [
  {
    id: `admin-122`,
    exact: false,
    path: MainRoutes?.root,
    component: Dashboard,
  },
  {
    id: `admin-123`,
    exact: false,
    path: NAV_ROUTES?.dashboard,
    component: Dashboard,
  },
  {
    id: `admin-124`,
    exact: false,
    path: NAV_ROUTES?.profile,
    component: Profile,
  },
  {
    id: `admin-125`,
    exact: false,
    path: NAV_ROUTES?.notifications,
    component: Notification,
  },
  {
    id: `admin-126`,
    exact: false,
    path: NAV_ROUTES?.setting,
    component: Setting,
  },
  {
    id: `admin-127`,
    exact: false,
    path: NAV_ROUTES?.support,
    component: Support,
  },
  {
    id: `admin-128`,
    exact: false,
    path: NAV_ROUTES?.transaction,
    component: Transaction,
  },
  {
    id: `admin-129`,
    exact: false,
    path: NAV_ROUTES?.wallet,
    component: Wallet,
  },
  {
    id: `admin-130`,
    exact: false,
    path: ADMIN_ROUTES?.dashboard,
    component: WalletListing,
  },
  {
    id: `admin-131`,
    exact: false,
    path: ADMIN_ROUTES?.transaction,
    component: TransactionsListing,
  },
  {
    id: `admin-132`,
    exact: false,
    path: ADMIN_ROUTES?.users,
    component: UsersListing,
  },
  {
    id: `admin-133`,
    exact: false,
    path: ADMIN_ROUTES?.payment_methods,
    component: PaymentGatewaysListing,
  },
  {
    id: `admin-130`,
    exact: false,
    path: ADMIN_ROUTES?.service_provider,
    component: ServiceProviderListing,
  },
];
